import React from 'react';
import PropTypes from 'prop-types';
import { FDIcon, FDStack } from '@facet-wealth/design';
import { BodyTextMedium } from 'Packages/FacetDesign/Components';
import { inputDefaultProps } from 'Packages/FacetDesign/Components/propTypes';

const SecondaryPersonIdentityVerification = ({ value, label }) => {
  const icon = value === true ? 'identityVerified' : 'identityNotVerified';
  return (
    <FDStack direction={'row'} alignSelf={'flex-end'} spacing={1}>
      <BodyTextMedium value={label} />
      <FDIcon icon={icon} size={'md'} />
    </FDStack>
  );
};

SecondaryPersonIdentityVerification.defaultProps = {
  label: inputDefaultProps.label,
  value: undefined,
};

SecondaryPersonIdentityVerification.propTypes = {
  label: PropTypes.object,
  value: PropTypes.bool,
};

export default SecondaryPersonIdentityVerification;
